import React, { useState } from 'react';
import { Card, Button, Table, Badge, Spinner, Modal, Form, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useQuery } from 'react-query';
import { BAOVECAPVIEN_API, DUYETBAOVECAPVIEN_API } from '@app/utils/apiUrl';
import { trangThaiBaoVeCapVienValue, objectTrangThaiBaoVeCapVien } from '@app/utils/define';
import { Get, Put } from '@app/utils/httpProvider';
import moment from 'moment';
import { toast } from 'react-toastify';
import QuyetDinhCapVienModal from './QuyetDinhCapVienModal';

const DuyetBaoVeCapVien = ({ hoSoId }) => {
    const [showModal, setShowModal] = useState(false);
    const [viewMode, setViewMode] = useState('list');
    const [dataEdit, setDataEdit] = useState(null);
    const [trangThai, setTrangThai] = useState('');
    const [isSaving, setIsSaving] = useState(false);

    const { isLoading, data: queryData, refetch } = useQuery(
        ['duyetBaoVeCapVienData', hoSoId],
        () => Get(`${BAOVECAPVIEN_API.GET_BY_HOSO_ID}/${hoSoId}`),
        { 
            enabled: !!hoSoId,
            keepPreviousData: true
        }
    );

    let dataList = [];
    if (queryData) {
        if (Array.isArray(queryData)) {
            dataList = queryData;
        } else if (queryData.data && Array.isArray(queryData.data)) {
            dataList = queryData.data;
        } else if (queryData.data?.$values) {
            dataList = queryData.data.$values;
        } else {
            dataList = [queryData];
        }
    }

    const handleAction = (item) => {
        setDataEdit(item);
        setTrangThai(item.trangThai || trangThaiBaoVeCapVienValue.choQuyetDinh);
        setShowModal(true);
    };

    const submitDuyet = async () => {
        if (!trangThai) {
            toast.warning('Vui lòng chọn trạng thái!');
            return;
        }

        const payload = {
            Id: dataEdit.id,
            HoSoNghienCuuSinhId: hoSoId,
            NgayBaoVe: dataEdit.ngayBaoVe || null,
            TrangThai: trangThai
        };

        setIsSaving(true);
        try {
            const res = await Put(DUYETBAOVECAPVIEN_API.DUYET_HO_SO, dataEdit.id, payload);
            if (res && (res.status === 200 || res.status === 201 || res.status === 204 || res.id || res.success)) {
                toast.success('Cập nhật trạng thái thành công!');
                refetch();
                setShowModal(false);
            } else {
                toast.error(res?.message || 'Có lỗi xảy ra');
            }
        } catch (error) {
            toast.error(error?.message || 'Có lỗi xảy ra');
        } finally {
            setIsSaving(false);
        }
    };

    const renderTrangThai = (val) => {
        switch (val) {
            case trangThaiBaoVeCapVienValue.choQuyetDinh: return <Badge variant="warning">Chờ quyết định</Badge>;
            case trangThaiBaoVeCapVienValue.choBaove: return <Badge variant="info">Chờ bảo vệ</Badge>;
            case trangThaiBaoVeCapVienValue.duDieuKien: return <Badge variant="primary">Đủ điều kiện</Badge>;
            case trangThaiBaoVeCapVienValue.hoanThanh: return <Badge variant="success">Hoàn thành</Badge>;
            default: return <Badge variant="secondary">Chưa xác định</Badge>;
        }
    };

    return (
        <>
        <Card className="h-100">
            <Card.Header>
                <div className="d-flex justify-content-between align-items-center">
                    <h5 className="font-weight-bold text-primary m-0">Bảo vệ luận án cấp viện</h5>
                </div>
            </Card.Header>
            <Card.Body>
                {isLoading ? (
                    <div className="text-center p-5">
                        <Spinner animation="border" variant="primary" />
                    </div>
                ) : (
                    <div className="table-responsive">
                        <Table striped bordered hover>
                            <thead>
                                <tr>
                                    <th className="text-center" width="50">STT</th>
                                    <th className="text-center">Ngày bảo vệ dự kiến</th>
                                    <th className="text-center">Trạng thái</th>
                                    <th className="text-center" width="120">Thao tác</th>
                                </tr>
                            </thead>
                            <tbody>
                                {dataList && dataList.length > 0 ? (
                                    dataList.map((item, index) => (
                                        <tr key={item.id}>
                                            <td className="text-center">{index + 1}</td>
                                            <td className="text-center">
                                                {item.ngayBaoVe ? moment(item.ngayBaoVe).format('DD/MM/YYYY') : ''}
                                            </td>
                                            <td className="text-center">{renderTrangThai(item.trangThai)}</td>
                                            <td className="text-center">
                                                <div className="d-flex justify-content-center text-nowrap">
                                                    <OverlayTrigger placement="top" overlay={(props) => (
                                                        <Tooltip id="button-tooltip" {...props}>
                                                            Cập nhật trạng thái
                                                        </Tooltip>
                                                    )}>
                                                        <Button variant="warning" size="sm" onClick={() => handleAction(item)} className="mr-1 text-white">
                                                            <i className="fas fa-tasks"></i>
                                                        </Button>
                                                    </OverlayTrigger>
                                                    <OverlayTrigger placement="top" overlay={(props) => (
                                                        <Tooltip id="button-tooltip" {...props}>
                                                            Quyết định cấp viện
                                                        </Tooltip>
                                                    )}>
                                                        <Button variant="primary" size="sm" onClick={() => { setDataEdit(item); setViewMode('quyetDinhCapVien'); }}>
                                                            <i className="fas fa-check-double"></i>
                                                        </Button>
                                                    </OverlayTrigger>
                                                </div>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="4" className="text-center text-muted">
                                            Chưa có dữ liệu Bảo vệ luận án cấp viện
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </Table>
                    </div>
                )}
            </Card.Body>
        </Card>

        {showModal && (
            <Modal show={showModal} onHide={() => setShowModal(false)} backdrop="static" keyboard={false} size="md">
                <Modal.Header closeButton className="bg-primary text-white">
                    <Modal.Title>Cập nhật trạng thái Bảo vệ luận án cấp viện</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group>
                            <Form.Label>Trạng thái</Form.Label>
                            <Form.Control 
                                as="select" 
                                value={trangThai}
                                onChange={(e) => setTrangThai(e.target.value)}
                            >
                                {objectTrangThaiBaoVeCapVien.map(t => (
                                    <option key={t.value} value={t.value}>{t.label}</option>
                                ))}
                            </Form.Control>
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowModal(false)} disabled={isSaving}>
                        <i className="fas fa-times mr-1"></i> Hủy
                    </Button>
                    <Button variant="primary" onClick={submitDuyet} disabled={isSaving}>
                        {isSaving ? 'Đang lưu...' : <><i className="fas fa-save mr-1"></i> Lưu lại</>}
                    </Button>
                </Modal.Footer>
            </Modal>
        )}
        {viewMode === 'quyetDinhCapVien' && dataEdit && (
            <QuyetDinhCapVienModal
                dataEdit={dataEdit}
                setViewMode={setViewMode}
                isView={false}
                isUserView={false}
            />
        )}
        </>
    );
};

export default DuyetBaoVeCapVien;
